// File: Navbar.js
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../Context/AuthContext';
import '../Assets/Styles/NavBar.css';

function Navbar({ onTabClick }) {
  const { token, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const isProductsPage = location.pathname === '/products';
  const searchParams = new URLSearchParams(location.search);
  const currentTab = searchParams.get('tab') || 'brands';

  const handleTabClick = (tab) => {
    // Only treat as a re-click if we're actually on the products page AND it's the same tab
    if (isProductsPage && currentTab === tab) {
      // Re-clicking the same tab → reset selection
      if (onTabClick) onTabClick(tab, true);
    } else {
      // Navigate to new tab, always include ?tab=
      navigate(`/products?tab=${tab}`);
      if (onTabClick) onTabClick(tab, false);
    }
  };

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <nav className="navbar">
      <div className="nav-left">
        <span onClick={() => navigate('/clients')}>Clients</span>
        <span
          className={isProductsPage && currentTab === 'brands' ? 'active' : ''}
          onClick={() => handleTabClick('brands')}
        >
          Brands
        </span>
        <span
          className={isProductsPage && currentTab === 'categories' ? 'active' : ''}
          onClick={() => handleTabClick('categories')}
        >
          Categories
        </span>
        <span
          className={isProductsPage && currentTab === 'all' ? 'active' : ''}
          onClick={() => handleTabClick('all')}
        >
          Items
        </span>
        <span onClick={() => navigate('/cart')}>🛒</span>
      </div>

      <div className="nav-right">
        {token ? (
          <span onClick={handleLogout} style={{ cursor: 'pointer' }}>
            🔓
          </span>
        ) : (
          <span onClick={() => navigate('/login')}>Login</span>
        )}
      </div>
    </nav>
  );
}

export default Navbar;